import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import Keycloak from 'keycloak-js';
import Reducer from './reducers/Reducer';
import config from './config';
import App from './App';
import './scss/styles.scss';
import * as serviceWorker from './serviceWorker';
import Preloader from './components/Preloader';
import CabinetErrorPage from './components/CabinetErrorPage';
import SsoApi from './api/SsoApi';
import { getUserInfoAction, changeLangAction } from './actions/Actions';
import { addToStorage } from './Utils';
import { LOCAL_STORAGE_CLIENT_BIN, LOCAL_STORAGE_LANG_KEY } from './config/constants';
import { getValueFromStorage } from './utils/webStorage';

const keycloak = Keycloak(config.keycloak);

const initialState = {
  customer: null
};

let store;
let currentBin = null;
let userToken = null;

if (process.env.NODE_ENV !== 'development') {
  store = createStore(
    Reducer,
    initialState,
    applyMiddleware(thunk)
  );
} else {
  store = createStore(
    Reducer,
    initialState,
    applyMiddleware(thunk, createLogger())
  );
}

render(<Preloader />, document.getElementById('root'));

keycloak
  .init({ onLoad: 'check-sso' })
  .success((authenticated) => {
    if (authenticated) {
      store.dispatch({
        token: keycloak.token,
        type: 'UPDATE_TOKEN'
      });

      setInterval(() => {
        keycloak.updateToken(10)
        .success((isUpdated) => {
          if (isUpdated) {
            store.dispatch({
              token: keycloak.token,
              type: 'UPDATE_TOKEN'
            });
          }
        }).error(() => keycloak.logout());
      }, 10000);

    } else {
      store.dispatch({
        type: 'CLEAR'
      });

      keycloak.login();
    }
  });

store.subscribe(() => {
  const { token, customer, userInfo } = store.getState();

  if (!!token && userToken !== token) {
    userToken = token;
    SsoApi.token = token;
    store.dispatch(getUserInfoAction());
  }

  if (!!customer && customer.idDocNum && currentBin !== customer.idDocNum) {
    currentBin = customer.idDocNum;
    SsoApi.bin = currentBin;
    SsoApi.msisdn = userInfo.msisdn;

    const lang = getValueFromStorage(LOCAL_STORAGE_LANG_KEY);

    if (lang) {
      // SET LANG TO LOCAL STORAGE
      addToStorage(LOCAL_STORAGE_LANG_KEY, lang);
      store.dispatch(changeLangAction(lang));
    }
    // SET BIN TO LOCAL STORAGE
    // TO SAVE CLIENT COMPANY
    addToStorage(LOCAL_STORAGE_CLIENT_BIN, currentBin);
    render(
      <Provider store={store}>
        <BrowserRouter>
          <Route component={App} />
        </BrowserRouter>

      </Provider>,
      document.getElementById('root')
    );
  }

  // if (hasUserData) {
  //   if (customer && !!customer.idDocNum) {
  //     // set bin for SsoApi here
  //     SsoApi.bin = customer.idDocNum;
  //     render(
  //       <Provider store={store}>
  //         <BrowserRouter>
  //           <Route component={App} />
  //         </BrowserRouter>
  //       </Provider>,
  //       document.getElementById('root'),
  //     );
  //   } else {
  //     window.open(config.accountsUrl, '_self');
  //   }
  // } else if (false) {
  //   // render(CabinetErrorPage); // think of error page
  // } else {
  //   render(Preloader, document.getElementById('root'));
  // }
});

serviceWorker.unregister();
